import { render, staticRenderFns } from "./GoalDisplayCard.vue?vue&type=template&id=b5798dd6&scoped=true"
import script from "./GoalDisplayCard.vue?vue&type=script&lang=js"
export * from "./GoalDisplayCard.vue?vue&type=script&lang=js"
import style0 from "./GoalDisplayCard.vue?vue&type=style&index=0&id=b5798dd6&prod&scoped=true&lang=less"
import style1 from "./GoalDisplayCard.vue?vue&type=style&index=1&id=b5798dd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5798dd6",
  null
  
)

export default component.exports